import { render } from "./SelectKinship.vue?vue&type=template&id=c7562c9a"
import script from "./SelectKinship.vue?vue&type=script&lang=js"
export * from "./SelectKinship.vue?vue&type=script&lang=js"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__